/**
 * TODO: Refactor to use ReduxAsyncActions
 */

import * as R from 'ramda';
import React from 'react';
import dash_api from '../support/dash_api';
import AccountStore from '../stores/AccountStore';
import NotificationActions from './NotificationActions';
import { generateConstants, convertToChron } from '../support/utils';
import Link from '../../common/components/core/Link';

import Reducer from '../reducers';

const PRODUCT_FEED_FEEDS_LOADED = generateConstants('PRODUCT_FEED_FEEDS_LOADED');
const PRODUCT_FEED_CAMPAIGNS_LOADED = generateConstants('PRODUCT_FEED_CAMPAIGNS_LOADED');
const PRODUCT_FEED_RESOURCES_LOADED = generateConstants('PRODUCT_FEED_RESOURCES_LOADED');
const PRODUCT_FEED_JOBS_LOADED = generateConstants('PRODUCT_FEED_JOBS_LOADED');
const PRODUCT_FEED_CAMPAIGN_CREATED = generateConstants('PRODUCT_FEED_CAMPAIGN_CREATED');
const PRODUCT_FEED_CAMPAIGN_UPDATED = generateConstants('PRODUCT_FEED_CAMPAIGN_UPDATED');
const PRODUCT_FEED_CAMPAIGN_ARCHIVED = generateConstants('PRODUCT_FEED_CAMPAIGN_ARCHIVED');
const PRODUCT_FEED_FEED_SAVED = generateConstants('PRODUCT_FEED_FEED_SAVED');
const PRODUCT_FEED_FEED_CREATED = generateConstants('PRODUCT_FEED_FEED_CREATED');
const PRODUCT_FEED_FEED_ARCHIVED = generateConstants('PRODUCT_FEED_FEED_ARCHIVED');
const PRODUCT_FEED_RESOURCE_CREATED = generateConstants('PRODUCT_FEED_RESOURCE_CREATED');
const PRODUCT_FEED_TRANSFORMED_LOADED = generateConstants('PRODUCT_FEED_TRANSFORMED_LOADED');
const PRODUCT_FEED_TRANSFORMED_CREATED = generateConstants('PRODUCT_FEED_TRANSFORMED_CREATED');
const PRODUCT_FEED_CONFIG_LOADED = generateConstants('PRODUCT_FEED_CONFIG_LOADED');
const PRODUCT_FEED_CONFIG_CREATED = generateConstants('PRODUCT_FEED_CONFIG_CREATED');

// Action Creators
function fetchProductFeedsForApp() {
  return function productFeedFetcher(dispatch) {
    return dash_api.post('/v1/callback/product feed feed list read').then(function productFeedReceiver(payload) {
      dispatch({
        type: PRODUCT_FEED_FEEDS_LOADED.response,
        data: R.sortBy(R.prop('date'), payload.data.value),
      });
    });
  };
}

function fetchCampaignsForApp() {
  return function campaignFetcher(dispatch) {
    return dash_api.post('/v1/callback/product feed campaign list read').then(function campaignReceiver(payload) {
      dispatch({
        type: PRODUCT_FEED_CAMPAIGNS_LOADED.response,
        data: R.sortBy(R.prop('date'), payload.data.value),
      });
    });
  };
}

function fetchResourcesForApp() {
  return function resourcesFetcher(dispatch) {
    return dash_api.post('/v1/callback/product feed resource list read').then(function resourcesReceiver(payload) {
      dispatch({
        type: PRODUCT_FEED_RESOURCES_LOADED.response,
        data: R.sortBy(R.prop('date'), payload.data.value),
      });
    });
  };
}

function fetchTransformedForApp() {
  return function transformedFetcher(dispatch) {
    return dash_api.post('/v1/callback/product feed transformed list read').then(function resourcesReceiver(payload) {
      dispatch({
        type: PRODUCT_FEED_TRANSFORMED_LOADED.response,
        data: R.sortBy(R.prop('date'), payload.data.value),
      });
    });
  };
}

function fetchJobsForApp() {
  return function jobsFetcher(dispatch) {
    return dash_api
      .post('/v1/callback/product feed job list read')
      .then(function jobsReceiver(payload) {
        dispatch({
          type: PRODUCT_FEED_JOBS_LOADED.response,
          data: payload.data.value,
        });
      })
      .catch(() => {
        // debugger;
      });
  };
}

const MAX_CHECKS = 20;
/*
 *  Helper function to check job every second until it's complete
 */
function checkJobsOnInterval(transformedId) {
  let checks = 0;

  const interval = setInterval(() => {
    const transformedList = R.path(['product_feeds', 'transformed'], Reducer.getState());
    const transformed = R.find(R.propEq('id', transformedId), transformedList);
    if (R.contains(transformed.status || '', ['QUEUED', 'CREATING'])) {
      Reducer.dispatch(fetchJobsForApp());

      checks++;
      if (checks > MAX_CHECKS) {
        clearInterval(interval);
      }
    } else if (transformed.status === 'FAILED') {
      NotificationActions.showNotification('Failed to create your Deep Linked Feed', 'error');
      clearInterval(interval);
    } else {
      NotificationActions.showNotification(
        <span>
          Your Deep Linked Feed is ready!&nbsp;
          <Link
            to={`/ads/links/deep-linked-feeds/feed/${transformed.ads_campaign_id}`}
            testid="feed-ready"
            i13nLabel="Feed ready notification clicked"
          >
            Click Here
          </Link>
        </span>,
        'success',
        'Your Deep Linked Feed is ready! Click Here'
      );
      clearInterval(interval);
    }
  }, 2000);
}

function createCampaign(campaign, creation_id) {
  return function campaignCreator(dispatch) {
    return dash_api
      .post('/v1/callback/product feed campaign create', {
        campaign_data: campaign,
      })
      .then(function campaignReceiver(campaign_payload) {
        const campaignCreated = R.path(['data', 'value'], campaign_payload) || {};

        dispatch({
          type: PRODUCT_FEED_CAMPAIGN_CREATED.response,
          data: campaignCreated,
        });

        if (!campaign.feed_id || !campaign.resource_id) {
          return null;
        }

        // send email to user when feed is ready
        const account = AccountStore.getAccount();
        const user = {
          name: account.name,
          email: account.email,
        };

        return dash_api
          .post('/v1/callback/product feed job create', {
            channel: campaign.channel,
            three_p_code: campaign.three_p_code,
            measurement_params: campaign.measurement_params,
            campaign_name: campaign.name,
            tags: campaign.ad_type,
            header_mappings: campaign.header_mappings,
            url: campaign.url,
            campaign_id: R.path(['data', 'value', 'id'], campaign_payload),
            feed_id: campaign.feed_id,
            resource_id: campaign.resource_id,
            user: user,
            output_format: campaign.output_format,
            branch_ad_format: campaign.branch_ad_format,
          })
          .then(function jobReceiver(job_payload) {
            var job = R.path(['data', 'value'], job_payload);

            dispatch({
              type: PRODUCT_FEED_TRANSFORMED_CREATED.response,
              data: {
                app_id: job.app_id,
                id: job.new_resource_id,
                ads_raw_file_id: job.resource_id,
                ads_campaign_id: job.campaign_id,
                ads_product_feed_id: job.feed_id,
                creation_id: creation_id,
                status: job.status,
              },
            });

            if (job.status !== 'DONE') {
              checkJobsOnInterval(job.new_resource_id);
            }

            return {
              campaign_payload,
              job_payload,
            };
          });
      });
  };
}

function updateCampaign(campaign_id, newData) {
  return function campaignUpdater(dispatch) {
    return dash_api.post('/v1/callback/product feed campaign read', { campaign_id }).then((payload) => {
      const oldData = R.path(['data', 'value'], payload);

      const chron = convertToChron(newData);

      var campaign_data = R.assoc('schedule', chron, oldData);

      return dash_api
        .post('/v1/callback/product feed campaign update', {
          campaign_id,
          campaign_data,
        })
        .then((payload) => {
          dispatch({
            type: PRODUCT_FEED_CAMPAIGN_UPDATED.response,
            data: R.path(['data', 'value'], payload),
          });
        });
    });
  };
}

function archiveCampaign(campaign_id) {
  return function campaignArchiver(dispatch) {
    return dash_api
      .post('/v1/callback/product feed campaign delete', {
        campaign_id: campaign_id,
      })
      .then(function campaignArchived(campaign_payload) {
        dispatch({
          type: PRODUCT_FEED_CAMPAIGN_ARCHIVED.response,
          data: {
            campaign_id: campaign_id,
          },
        });
        return campaign_payload;
      });
  };
}

function archiveFeed(feed_id) {
  return function feedArchiver(dispatch) {
    return dash_api
      .post('/v1/callback/product feed feed delete', {
        feed_id: feed_id,
      })
      .then(function feedArchived(campaign_payload) {
        dispatch({
          type: PRODUCT_FEED_FEED_ARCHIVED.response,
          data: {
            feed_id: feed_id,
          },
        });
      });
  };
}

function saveProductFeed(feed) {
  return function productFeedSaver(dispatch) {
    return dash_api
      .post('/v1/callback/product feed resource update', {
        feed_id: feed.id,
        resource_id: feed.id,
        resource_data: feed,
      })
      .then(function productFeedReceiver(payload) {
        dispatch({
          type: PRODUCT_FEED_FEED_SAVED.response,
          data: payload.data.value,
        });
        return payload.data.value;
      });
  };
}

function createFileResource(file) {
  return function fileResourceCreator(dispatch) {
    const formData = new FormData();
    formData.append(file.name, file);

    return dash_api
      .post('/v1/product-feed/resource', formData)
      .then(({ data }) => {
        dispatch({
          type: PRODUCT_FEED_RESOURCE_CREATED.response,
          data: data.value,
        });
        return data.value;
      })
      .catch((e) => {
        dispatch({
          type: PRODUCT_FEED_RESOURCE_CREATED.error,
          data: e,
        });
      });
  };
}

function createUrlResource(url) {
  return function urlResourceCreator(dispatch) {
    return dash_api.post('/v1/callback/product feed resource create', { url }).then(function resourceReceiver(payload) {
      const resource = R.path(['data', 'value'], payload);

      if (resource.status) {
        dispatch({
          type: PRODUCT_FEED_RESOURCE_CREATED.response,
          data: resource.value,
        });
      }

      return resource.value;
    });
  };
}

function createFeed(feed) {
  return function feedCreator(dispatch) {
    if (!feed.resource_id) {
      return;
    }

    return dash_api
      .post('/v1/callback/product feed feed create', {
        feed_data: feed,
      })
      .then(function feedReceiver(payload) {
        dispatch({
          type: PRODUCT_FEED_FEED_CREATED.response,
          data: payload.data.value,
        });
        return payload.data.value;
      });
  };
}

function fetchConfigs() {
  return function configFetcher(dispatch) {
    return dash_api.post('/v1/callback/product feed config read').then((config) => {
      const providers = R.keys(R.path(['data', 'value'], config));
      dispatch({
        type: PRODUCT_FEED_CONFIG_LOADED.response,
        data: providers,
      });
      return providers;
    });
  };
}

function createConfig(three_p_code) {
  return function configCreator(dispatch) {
    return dash_api.post('/v1/callback/product feed config read').then((config) => {
      if (three_p_code in R.path(['data', 'value'], config)) {
        return;
      }

      return dash_api
        .post('/v1/callback/product feed config create', {
          three_p_code,
          enabled: true,
          link_fallback_method: 'ORIGINAL_URL',
        })
        .then((payload) => {
          dispatch({
            type: PRODUCT_FEED_CONFIG_CREATED.response,
            data: three_p_code,
          });
          return R.path(['data', 'value'], payload);
        });
    });
  };
}

export {
  fetchProductFeedsForApp,
  fetchResourcesForApp,
  fetchTransformedForApp,
  fetchJobsForApp,
  fetchCampaignsForApp,
  saveProductFeed,
  createFeed,
  archiveFeed,
  createCampaign,
  fetchConfigs,
  createConfig,
  archiveCampaign,
  createFileResource,
  createUrlResource,
  updateCampaign,
  PRODUCT_FEED_CAMPAIGN_CREATED,
  PRODUCT_FEED_CAMPAIGNS_LOADED,
  PRODUCT_FEED_CAMPAIGN_ARCHIVED,
  PRODUCT_FEED_CAMPAIGN_UPDATED,
  PRODUCT_FEED_JOBS_LOADED,
  PRODUCT_FEED_FEED_CREATED,
  PRODUCT_FEED_FEEDS_LOADED,
  PRODUCT_FEED_FEED_SAVED,
  PRODUCT_FEED_FEED_ARCHIVED,
  PRODUCT_FEED_RESOURCES_LOADED,
  PRODUCT_FEED_RESOURCE_CREATED,
  PRODUCT_FEED_TRANSFORMED_LOADED,
  PRODUCT_FEED_TRANSFORMED_CREATED,
  PRODUCT_FEED_CONFIG_LOADED,
  PRODUCT_FEED_CONFIG_CREATED,
};
